import React, { useContext, useState, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";
import { CurrencyContext } from "../../contexts/CurrencyContext";
import { UserContext } from "../../contexts/UserContext";
import { WishlistContext } from "../../contexts/WishlistContext";
import { CartContext } from "../../contexts/CartContext";
import { ThemeContext } from '../../contexts/ThemeContext';
import { FaCartPlus, FaRegTrashAlt } from "react-icons/fa";
import { HiOutlineMagicWand } from "react-icons/hi";
import { FaGift } from "react-icons/fa";
import { motion } from "framer-motion";
import { MdDashboard } from 'react-icons/md';
import { IoClose } from 'react-icons/io5';
import user from "../../public/images/profile.jpeg"
import { SnackbarTwo } from "../../components/ProductsGrid/SnackbarTwo";
import { useRouter } from 'next/router';
import { setImageSrc } from '../../utils/config';
import wishlistProducts from '../jsondatas/wishlistProducts.json';
import { Error404Order } from '../404';
import getRedisClient from '../../utils/redis';
import getRedisClientLocal from '../../utils/localredis';
import errorLogApi from '../../components/custom/ErrorLogApi';
import LogoutModal from '../../components/custom/LogoutModal';
import CustomPopup from "../../components/CustomPopup"; // Import CustomPopup
import useTracking from '../../components/custom/useTracking';
import LoadingAnimation from '../../components/custom/LoadingAnimation';
const Wishlist = () => {
  const { wishlist, removeFromWishlist, errorState,loading } = useContext(WishlistContext);
  const { formatCurrency } = useContext(CurrencyContext);
  const { clearUser, token, userDetails, goldPlanEnable } = useContext(UserContext);
  const { addToCart, isSnackbarVisible } = useContext(CartContext);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [popupConfig, setPopupConfig] = useState({});
  const [snackbarProduct, setSnackbarProduct] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const userType = userDetails?.user_type || 0;

  const theme = useContext(ThemeContext);
  const router = useRouter();
  const trackPage = useTracking('Wishlist Page');
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
// Custom Pop up function 
  const handleDisabledClick = (event) => {
    event.preventDefault();
    openPopup({
      type: 'info',
      title: 'Preview Mode',
      subText: 'Actions like "Remove From Wishlist" are disabled during preview.',
      onConfirm: closePopup,
      onClose: closePopup,
      showConfirmButton: false,
        showCancelButton: false,
        cancelLabel: "close",
      autoClose: 4,
    });
  };

  const handleDisabledClickCart = (event) => {
    event.preventDefault();
    openPopup({
      type: 'info',
      title: 'Preview Mode',
      subText: 'Actions like "Added to Cart" are disabled during preview.',
      onConfirm: closePopup,
      onClose: closePopup,
      showConfirmButton: false,
        showCancelButton: false,
        cancelLabel: "close",
      autoClose: 4,
    });
  };

  const handleDisabledClickImage = (event) => {
    event.preventDefault();
    openPopup({
      type: 'info',
      title: 'Preview Image',
      subText: 'Product details are disabled in this preview. However, you can view product details on the product listing page.',
      cancelLabel: "close",
      onClose: closePopup,
      showConfirmButton: false,
        showCancelButton: false,
        autoClose: 4,
    });
  };

  const openPopup = (config) => {
    setPopupConfig(config);
    setPopupOpen(true);
  };

  const closePopup = () => {
    setPopupOpen(false);
  };

  const handleRemove = (product) => {
    openPopup({
      type: 'warning',
      title: "Are you sure?",
      subText: "You want to delete this from your wishlist",
      confirmLabel: "Yes, remove",
    cancelLabel: "No, keep it",
    showCloseIcon : false,
      onConfirm: async () => {
        const productToRemove = {
          id: product.product_id,
          ...product,
        };
        removeFromWishlist(productToRemove);
        openPopup({
          type: 'error',
          title: "Deleted!",
          subText: "The item has been removed from your wishlist.",
          onConfirm: closePopup,
          onClose: closePopup,
          autoClose: 2,
        });
      },
      onClose: closePopup,
     
    });
  };

  const handleAddToCart = (product) => {
   
    addToCart(product);
    setSnackbarProduct(product);
    setSnackbarOpen(true);
  };

  const handleLogout = () => {
    setIsLogoutModalOpen(true);
  };

  const confirmLogout = () => {
    clearUser();
    setIsLogoutModalOpen(false);
    window.location.href = "/";
    // router.push("/");
  };
useEffect(() => {
  
  trackPage();
}, []);
  const backdropVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { duration: 0.3, ease: "easeOut" }
    }
  };

  const sidebarVariants = {
    hidden: {
      x: '-100%',
      opacity: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    },
    visible: {
      x: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut",
        when: "beforeChildren",
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { x: -10, opacity: 0 },
    visible: { 
      x: 0, 
      opacity: 1,
      transition: { duration: 0.4, ease: "easeOut" }
    }
  };

  const closeIconVariants = {
    initial: { scale: 1 },
    hover: { scale: 1.2, rotate: 90 },
    tap: { scale: 0.8 }
  };

  const containerVariants = {
    hidden: { 
      scale: 0.95, 
      rotate: -10, 
      opacity: 0
    },
    visible: {
      scale: 1, 
      rotate: 0, 
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeInOut",
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const childVariants = {
    hidden: {
      y: 20,
      opacity: 0 
    },
    visible: {
      y: 0, 
      opacity: 1,
      transition: {
        duration: 0.6, 
        ease: "easeOut" 
      }
    }
  };

  const headerVariants = {
    hidden: {
      scale: 0.85,
      opacity: 0,
      y: -40,
      rotate: -15,
    },
    visible: {
      scale: [0.85, 1.05, 1],
      opacity: 1,
      y: [0, -20, 0],
      rotate: [0, 10, -5, 0],
      transition: {
        type: "spring",
        stiffness: 90,
        damping: 15,
        delay: 0.2,
        duration: 2.5,
      },
    },
  };
if(theme.siteStatus ===1 && loading){
  return <LoadingAnimation />
}
  return (
    <>
      <div className="xl:container px-4 py-4 flex justify-between ">
        <div className="flex gap-3 items-center">
          <Link href="/" className="text-primary text-base">
            <i className="fas fa-home"></i>
          </Link>
          <div className="flex gap-3 items-center mt-1">
            <span className="text-sm text-gray-500">
              <i className="fas fa-chevron-right "></i>
            </span>
            <p className="text-gray-500  font-medium uppercase  "> Wishlist</p>
          </div>
        </div>
      </div>

      <div className="block xl:container px-4 lg:grid grid-cols-12 items-start gap-6 pt-4 pb-16">
        <div className="lg:hidden">
          <div className="bg-gray-50 p-4 flex items-center justify-center shadow rounded-t-lg">
            <div className="flex items-center">
              <Image src={user} alt="User" className="rounded-full w-14 h-14 border border-gray-300" />
              <div className="ml-3">
                <p className="text-gray-600">Hello..</p>
                <h4 className="text-gray-800 font-semibold capitalize">{userDetails?.name}..</h4>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap justify-between p-4 bg-gray-50 shadow rounded-b-lg">
            <div className="w-1/2 p-2">
              <Link href="/profile/User" className="flex flex-col items-center bg-white rounded-lg shadow py-3 hover:text-primary">
                <span className="text-xs text-center">Manage Account</span>
              </Link>
            </div>
            <div className="w-1/2 p-2">
              <Link href="/profile/Address" className="flex flex-col items-center  bg-white  rounded-lg shadow py-3 hover:text-primary">
                <span className="text-xs text-center">Manage Address</span>
              </Link>
            </div>
            <div className="w-1/2 p-2">
              <Link href="/profile/ChangePassword" className="flex flex-col bg-white items-center rounded-lg shadow py-3 hover:text-primary">
                <span className="text-xs text-center">Change Password</span>
              </Link>
            </div>
            <div className="w-1/2 p-2">
              <Link href="/profile/orders" className="flex flex-col items-center bg-white  rounded-lg shadow py-3 hover:text-primary">
                <span className="text-xs text-center">My Order History</span>
              </Link>
            </div>
            {goldPlanEnable && (
              <div className="w-1/2 p-2">
                <Link href="/profile/GoldPlans" className="flex flex-col items-center bg-white rounded-lg shadow py-3 hover:text-primary">
                  <span className="text-xs text-center">Gold Plans</span>
                </Link>
              </div>
            )}
      {/* B2b & owner owner user for bid & ask - 23/08/2024 */}
      {(userDetails?.user_type === 2 || userDetails?.user_type === 3) && (
              <div className="w-1/2 p-2">
                <Link href="/profile/BidAsk" className="flex flex-col items-center bg-white  rounded-lg shadow py-3 hover:text-primary">
                  <span className="text-xs text-center">Bid & Ask</span>
                </Link>
              </div>
            )}
            <div className="w-1/2 p-2">
              <Link href="/profile/Wishlist" className="flex flex-col items-center  border-2 border-primary  rounded-lg shadow py-3 hover:text-primary">
                <span className="text-xs text-center">My Wishlist</span>
              </Link>
            </div>
            <div className="w-1/2 p-2">
              <a href="#" onClick={handleLogout} className="flex flex-col items-center  rounded-lg shadow py-3 hover:text-primary">
                <span className="text-xs text-center">Logout</span>
              </a>
            </div>
          </div>
        </div>

        {theme.siteStatus !== 0 && (
          <div className="col-span-3 hidden lg:block">
            <div className="px-4 py-3 shadow flex bg-gray-100 items-center gap-4">
              <div className="flex-shrink-0">
                <Image
                  src={user}
                  className="rounded-full w-14 h-14 p-1 border border-gray-200 object-cover"
                />
              </div>
              <div>
                <p className="text-gray-600">Hello..</p>
                <h4 className="text-gray-800  capitalize font-semibold">
                  {userDetails?.name}..{" "}
                </h4>
              </div>
            </div>

            <div className="mt-6 bg-gray-100 shadow rounded p-4 divide-y divide-gray-200 space-y-4 text-gray-600">
              <div className="space-y-1 pl-8">
                <Link
                  href="/profile/User"
                  className="relative text-base font-medium capitalize hover:text-primary transition block"
                >
                  Manage Account
                  <span className="absolute -left-8 top-0 text-base">
                    <i className="far fa-address-card"></i>
                  </span>
                </Link>

                <Link
                  href="/profile/Address"
                  className="hover:text-primary transition capitalize block "
                >
                  Manage Address
                </Link>
                <Link
                  href="/profile/changePassword"
                  className="hover:text-primary transition capitalize block"
                >
                  Change Password
                </Link>
              </div>

              <div className="space-y-1 pl-8 pt-4">
                <Link
                  href="/profile/orders"
                  className="relative text-base font-medium capitalize hover:text-primary transition block "
                >
                  My Order History
                  <span className="absolute -left-8 top-0 text-base">
                    <i className="fas fa-gift"></i>
                  </span>
                </Link>
              </div>
              {goldPlanEnable && <div className="space-y-1 pl-8 pt-4">
                <Link
                  href="/profile/GoldPlans"
                  className="relative text-base font-medium capitalize hover:text-primary transition block "
                >
                  Gold Plans
                  <span className="absolute -left-8 top-0 text-base">
                    <i className="fas fa-crown"></i>
                  </span>
                </Link>
              </div>}
                {/* B2b & owner owner user for bid & ask - 23/08/2024 */}
                {(userDetails?.user_type === 2 || userDetails?.user_type === 3) && (
                <div className="space-y-1 pl-8 pt-4">
                  <Link
                    href="/profile/BidAsk"
                    className="relative text-base font-medium capitalize hover:text-primary transition block "
                  >
                    Bid & Ask
                    <span className="absolute -left-8 top-0 text-base">
                      <i className="fas fa-gavel"></i>
                    </span>
                  </Link>
                </div>
              )}

              <div className="space-y-1 pl-8 pt-4 font-semibold ">
                <Link
                  href="/profile/Wishlist"
                  className="relative text-base  capitalize hover:text-primary transition block text-primary"
                >
                  My Wishlist
                  <span className="absolute -left-8 top-0 text-base ">
                    <i className="far fa-heart"></i>
                  </span>
                </Link>
              </div>

              <div className="space-y-1 pl-8 pt-4">
                <Link
                  href="#"
                  onClick={handleLogout}
                  className="relative text-base font-medium capitalize hover:text-primary transition block"
                >
                  Logout
                  <span className="absolute -left-8 top-0 text-base">
                    <i className="fas fa-sign-out-alt"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        )}
{/* double container issue fixed - 13-08-2024 */}
        <div className={`${theme.siteStatus !== 0 ? 'col-span-9' : 'col-span-12'} mt-6 lg:mt-0 space-y-4`}>
          {errorState ? <Error404Order /> : (
            <>
              <div className="p-4">
                <h1
                  variants={headerVariants}
                  initial="hidden"
                  animate="visible"
                  className="text-xl mb-8 md:text-2xl font-bold text-center text-primary decoration-pink-500"
                >
                  {/* conditonal rendering for wishlist title */}
           {wishlist.length !==0 &&<>  <FaGift className="inline-block mr-2" size={32} /> Dreamy Picks Await! </> }     
                </h1>
                {(theme.siteStatus === 0 ? wishlistProducts.product : wishlist)?.length === 0 ? (
                  <div className="flex flex-col items-center justify-center text-xl text-white p-10 rounded-md">
                    <span className="text-6xl animate-bounce">💔</span>
                    <span className="text-primary">
                      Your wishlist is currently empty.
                    </span>
                    <span className="text-primary">Start adding items to it!</span>
                  </div>
                ) : (
                  <div
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                    className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4"
                  >
                    {(theme.siteStatus === 0 ? wishlistProducts.product : wishlist).map((product) => (
                      <div
                        key={product.product_id}
                        className="relative bg-white  overflow-hidden shadow-sm"
                      >
                        <div className="flex flex-col lg:flex-row">
                          <div className="flex-shrink-0 w-full lg:w-44 lg:h-44 aspect-square">
                            <Link href={`${product.url}`} onClick={theme.siteStatus === 0 ? handleDisabledClickImage : undefined}>
                            
                               <Image
                                className="w-full h-full object-cover"
                                src={setImageSrc(product.json["Images"], product.json["Product Name"])}
                                alt={product.json["Product Name"]}
    width={600} // Set appropriate width, adjust as necessary
    height={400} // Set appropriate height, adjust as necessary
                              />
                            </Link>
                          </div>
                          <div className="p-4 flex flex-col justify-between flex-grow">
                            <Link href={`${product.url}`}>
                              <h1
                                variants={childVariants}
                                className="text-md lg:text-sm xl:text-xl text-primary mb-2 max-w-full xl:max-w-[17rem] lg:max-w-[8rem]"
                                style={{ maxHeight: '4.5rem' }}
                              >
                                {product.json["Product Name"]}
                              </h1>
                              {/* Price rule Added 04/09/24 */}
                              <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 items-start sm:items-center text-lg mb-2">
                                <h3 className="font-bold text-md xl:text-xl text-gray-700 mb-2 ">
                                  {
                                    ((product.json.special_price_status == 1) && (userType == 1 || userType == 0)) ? (
                                      <>
                                        <span  variants={childVariants}>
                                        <span className="text-green-700 text-md md:text-xl ">{formatCurrency(product.json.special_price)} </span>
                                          <span className="ml-1 line-through text-red-500 text-sm md:text-lg">{formatCurrency(product.json.price)} </span>
                                        </span>
                                      </>

                                    ) : (<span  variants={childVariants}  className="text-lg font-bold text-gray-800">{formatCurrency(product.json.price)}</span>)
                                  }
                                </h3>
                              </div> 
                            </Link>
                          </div>
                        </div>
                        <div
                          variants={childVariants}
                          className="absolute top-4 right-0 mb-4 mr-4"
                          initial={{ scale: 0 }}
                          animate={{ scale: 1 }}
                          whileHover={{ scale: 1.1, rotate: -5 }}
                          whileTap={{ scale: 0.95, rotate: 5 }}
                          transition={{
                            type: "spring",
                            stiffness: 260,
                            damping: 20,
                          }}
                          onClick={(event) => theme.siteStatus !== 0 ? handleRemove(product) : handleDisabledClick(event)}
                        >
                          <div
                            className="p-2 rounded-full bg-white"
                            variants={childVariants}
                            whileHover={{
                              y: -4,
                              boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.3)",
                            }}
                          >
                            <FaRegTrashAlt className="text-red-500 cursor-pointer text-sm lg:text-xl hover:text-red-600" />
                          </div>
                        </div>
                        <div
                          variants={childVariants}
                          className="absolute bottom-0 cursor-pointer right-0 mb-4 mr-4"
                          initial={{ scale: 0 }}
                          animate={{ scale: 1 }}
                          whileHover={{ scale: 1.1, rotate: 5 }}
                          whileTap={{ scale: 0.95, rotate: -5 }}
                          transition={{
                            type: "spring",
                            stiffness: 260,
                            damping: 20,
                          }}
                          onClick={(event) => theme.siteStatus !== 0 ? handleAddToCart(product) : handleDisabledClickCart(event)}
                        >
                          <div
                            className="p-2 rounded-full bg-white"
                            variants={childVariants}
                            whileHover={{
                              y: -4,
                              boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.3)",
                            }}
                          >
                            <FaCartPlus className="text-primary hover:text-primary-dark" size={24} />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {isSnackbarVisible ? (
                <SnackbarTwo
                  product={snackbarProduct}
                  isOpen={snackbarOpen}
                  setIsOpen={setSnackbarOpen}
                />
              ) : (
                false
              )}
            </>
          )}
        </div>
      </div>
      <LogoutModal 
        isOpen={isLogoutModalOpen} 
        onClose={() => setIsLogoutModalOpen(false)} 
        onConfirm={confirmLogout}
      />
      <CustomPopup
        isOpen={isPopupOpen}
        type={popupConfig.type}
        title={popupConfig.title}
        subText={popupConfig.subText}
        confirmLabel={popupConfig.confirmLabel}
        cancelLabel={popupConfig.cancelLabel}
        onConfirm={popupConfig.onConfirm}
        showCloseIcon={popupConfig.showCloseIcon}
        onClose={popupConfig.onClose}
        autoClose={popupConfig.autoClose}
        showConfirmButton={popupConfig.showConfirmButton}
        showCancelButton={popupConfig.showCancelButton}
      />
    </>
  );
};

function sanitizeHostname(host) {
  const hostname = new URL(`https://${host}`).hostname;
  return hostname;
}

const logError = (endpoint, error) => {
  const responseData = error.response?.data ?? '';
  errorLogApi({
    job_id: "",
    endpoint: endpoint,
    payload: '',
    responseData: responseData,
    errorMsg: error
  });
};

function parseCookies(cookieHeader) {
  const cookies = {};
  if (!cookieHeader) return cookies;
  const pairs = cookieHeader.split(';');
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].trim().split('=');
    cookies[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return cookies;
}

export async function getServerSideProps(context) {
  const { req, res } = context;

  const cookies = parseCookies(req.headers.cookie);
  const userDetails = cookies.userDetails ? JSON.parse(cookies.userDetails) : null;
 
  const hostname = req.headers.host === "localhost:3000" ? process.env.NEXT_PUBLIC_WEB_HOST : sanitizeHostname(req.headers.host);
  const redishostname = sanitizeHostname(req.headers.host);
  const redis = redishostname.startsWith('localhost') ? getRedisClientLocal() : getRedisClient();
 
  if (!hostname.startsWith('preview.') && !userDetails) {
    const url = req.url
    res.setHeader("Set-Cookie", `initialReferrer=${url}; Path=/;`)
    return {
      redirect: {
        destination: '/auth/SignIn',
        permanent: false,
      },
    };
  }



  const previewUrl = req.headers.host === "localhost:3000"
    ? "https://preview.jpencil.in/?pid=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqYm9faWQiOjIzMywic2l0ZV9zdGF0dXMiOjAsImlhdCI6MTcxNDY0MzI4MX0.QXsuG6PL2rBZP92YZMTeMRnO3at8Sfq2gOf22rG6jeg"
    : req.url;

  const urlObj = new URL(previewUrl, `http://${hostname}`);
  const pid = urlObj.searchParams.get('pid');

  if (hostname.startsWith('preview.')) {
    const innerJson = JSON.stringify({
      domain: hostname,
      token: pid
    });

    const payload = {
      data: innerJson
    };

    try {
      const response = await axios.post(`https://${hostname}/api/user/getJbo`, payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      return { props: { products: response.data } };
    } catch (error) {
      logError('getJbo', error);
    }
  }

  try {
    const cachedProducts = await redis.get(hostname);

    if (cachedProducts) {
      return { props: { products: JSON.parse(cachedProducts) } };
    }

    const innerJson = JSON.stringify({ domain: hostname });
    const payload = {
      data: JSON.stringify({ domain: hostname })
    };

    const response = await axios.post(`https://${hostname}/api/user/getJbo`, payload, {
      headers: { 'Content-Type': 'application/json' }
    });

    if (response.data && Object.keys(response.data).length) {
      return { props: { products: response.data } };
    }

    logError('getJbo', new Error('No data returned from API'));
    return { props: { products: [] } };
  } catch (error) {
    logError('getJbo', error);
    return { props: { products: [] } };
  }
}

export default Wishlist;
